/**
 * Products Module Routes
 *
 * Route definitions for the Products module.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/products',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.products',
        },
        children: [
            {
                path: '',
                name: 'products-list',
                component: () => import('./views/ProductList.vue'),
                meta: {
                    title: 'All Products',
                    moduleKey: 'settings.products',
                },
            },
            {
                path: 'create',
                name: 'products-create',
                component: () => import('./views/ProductCreate.vue'),
                meta: {
                    title: 'Add Product',
                },
            },
            {
                path: ':id',
                name: 'products-detail',
                component: () => import('./views/ProductDetail.vue'),
                meta: {
                    title: 'Product Details',
                },
            },
        ],
    },
]

export default routes
